


























import { mixins } from 'vue-class-component'
import { Component, Prop } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import { RecordTypeMaster } from '@/modules/RecordType/interfaces/record-type'
import RecordTypesHandler from '@/mixins/record-types'
import { Case } from '@/modules/Case/interfaces/case'
import { IQuoteRecordTypeInput } from '@/modules/Quote/interfaces/quote-form'

@Component({
  components: {
    AppTextSearch
  }
})
export default class QuoteFormRecordType extends mixins(RecordTypesHandler) {
  @Prop({ type: Object as () => IQuoteRecordTypeInput }) value!: IQuoteRecordTypeInput
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case

  get disable () {
    return !!this.caseInfo
  }

  mounted () {
    this.getRecordTypes(RecordTypeMaster.POLICY)
  }

  recentlyClickHandler (index: number) {
    if (this.disable) {
      return
    }
    const recordType = this.recentlyUsedRecordTypes[index]
    this.candidateRecordTypes.push()
    const findIndex = this.candidateRecordTypes.findIndex(rt => rt.name === recordType.name)
    if (findIndex === -1) {
      this.candidateRecordTypes = [...this.candidateRecordTypes, recordType]
    }
    this.value.recordType = {
      id: +recordType.id,
      name: recordType.name
    }
  }

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
